/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../../connect/v2/resources/address';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "corporate_card": {
        "nested": {
          "resources": {
            "nested": {
              "CardHolder": {
                "fields": {
                  "token": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "creditLineToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "profileToken": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "type": {
                    "type": ".squareup.corporate_card.resources.CardHolder.Type",
                    "id": 4,
                    "rule": "optional"
                  },
                  "status": {
                    "type": ".squareup.corporate_card.resources.CardHolder.Status",
                    "id": 5,
                    "rule": "optional"
                  },
                  "billingAddress": {
                    "type": ".squareup.connect.v2.resources.Address",
                    "id": 6,
                    "rule": "optional"
                  },
                  "shippingAddress": {
                    "type": ".squareup.connect.v2.resources.Address",
                    "id": 7,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Type": {
                    "values": {
                      "TYPE_DO_NOT_USE": 0,
                      "PRIMARY": 1,
                      "SUPPLEMENTARY": 2
                    }
                  },
                  "Status": {
                    "values": {
                      "STATUS_DO_NOT_USE": 0,
                      "ACTIVE": 1,
                      "INACTIVE": 2
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.corporate_card?.nested?.resources?.nested?.CardHolder && !$root.nested?.squareup?.nested?.corporate_card?.nested?.resources?.nested?.CardHolder?.nested?.Type && !$root.nested?.squareup?.nested?.corporate_card?.nested?.resources?.nested?.CardHolder?.nested?.Status) {
  $root.addJSON(jsonData);
}

/**
 * --
 * @desc A card holder represents an entity which uses a card
 * --
 *
 * SOURCE CardHolder @ squareup/corporate_card/resources/card_holder.proto at 11:1
 */
export const CardHolder = $root.lookupType('squareup.corporate_card.resources.CardHolder');
fixType(CardHolder);
Builder.createAndAttachToType(CardHolder);
/**
 * SOURCE Type @ squareup/corporate_card/resources/card_holder.proto at 13:3
 */
CardHolder.Type = $root.lookupEnum('squareup.corporate_card.resources.CardHolder.Type').values;
/**
 * SOURCE Status @ squareup/corporate_card/resources/card_holder.proto at 19:3
 */
CardHolder.Status = $root.lookupEnum('squareup.corporate_card.resources.CardHolder.Status').values;